import CoreSkill from "../models/CoreSkill";
import { SystemErrors } from "../definitions/systemErrors";

export default class CoreSkillService {
  // public static sendAddRequest(ApiService: any): Promise<boolean> {
  //   return new Promise((resolve, reject) => {
  //     ApiService.get(`/coreskill/request/${skillName}`, "")
  //       .then((result) => {
  //         if (!result.data || result.data.statusCode != SystemErrors.Authentication.Success || !result.data.value) {
  //           resolve(false);
  //         } else {
  //           resolve(result.data.value);
  //         }
  //       })
  //       .catch((error) => {
  //         reject(error);
  //       });
  //   });
  // }

  public static _getList(apiService: any, client = false, path = ""): Promise<CoreSkill[]> {
    return new Promise((resolve, reject) => {
      apiService
        .get(`${client ? "/client" : ""}/coreskill${path}`, "")
        .then((result: any) => {
          if (!result.data || result.data.statusCode != SystemErrors.Authentication.Success || !result.data.value) {
            resolve([]);
          } else {
            resolve(
              result.data.value.map((doc: any) => {
                return { id: doc.id, ...doc } as CoreSkill;
              })
            );
          }
        })
        .catch((error: any) => {
          reject(error);
        });
    });
  }
}
